import { useEffect, useState } from 'react';
import { resolveMediaUrl } from '@/utils/mediaUrl';

export function isProfilePhotoViewPath(url) {
  return typeof url === 'string' && url.includes('/api/people/') && url.includes('/profile-photo');
}

export function isShiftPhotoViewPath(url) {
  return typeof url === 'string'
    && url.includes('/api/scheduling/shifts/')
    && url.includes('/photos/')
    && url.includes('/file');
}

export function isPrivateImagePath(url) {
  return isProfilePhotoViewPath(url) || isShiftPhotoViewPath(url);
}

export async function openPrivateImage(url) {
  if (!url) return;
  if (!isPrivateImagePath(url)) {
    window.open(url, '_blank', 'noopener');
    return;
  }
  const objectUrl = await fetchProfilePhotoObjectUrl(url);
  if (objectUrl) window.open(objectUrl, '_blank', 'noopener');
}

export function withPhotoVersion(url) {
  if (!isProfilePhotoViewPath(url)) return url;
  const joiner = url.includes('?') ? '&' : '?';
  return `${url}${joiner}v=${Date.now()}`;
}

export async function fetchProfilePhotoObjectUrl(url) {
  const base = process.env.REACT_APP_BACKEND_URL || '';
  const path = url.startsWith('/') ? url : `/${url}`;
  const full = url.startsWith('http') ? url : `${base}${path}`;
  const token = localStorage.getItem('access_token');
  if (!token) return '';
  const response = await fetch(full, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) return '';
  const blob = await response.blob();
  return URL.createObjectURL(blob);
}

export function useProfilePhotoSrc(url) {
  const privatePhoto = isPrivateImagePath(url);
  const [src, setSrc] = useState(privatePhoto ? '' : resolveMediaUrl(url));

  useEffect(() => {
    if (!isPrivateImagePath(url)) {
      setSrc(resolveMediaUrl(url));
      return undefined;
    }
    let active = true;
    let objectUrl = '';
    fetchProfilePhotoObjectUrl(url)
      .then((next) => {
        if (!active) {
          if (next) URL.revokeObjectURL(next);
          return;
        }
        objectUrl = next || '';
        setSrc(objectUrl);
      })
      .catch(() => {
        if (active) setSrc('');
      });
    return () => {
      active = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [url]);

  return src;
}

export function ProfilePhotoImg({ url, className, alt, onClick }) {
  const src = useProfilePhotoSrc(url);
  if (!src) return <div className={className} />;
  return <img src={src} alt={alt || ''} className={className} onClick={onClick} />;
}
